<div class="modal-content">
    <div class="modal-header text-center">
        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/user-white.svg">
        <h3 class="mt-2">{{escritorio.ejecutivo}}</h3>
        <hr class="w-75 mx-auto">
        <h2>¿DESEA CERRAR SESIÓN?</h2>
    </div>
    <div class="modal-footer">
        <div class="row mx-auto">

            <div class="col-12 text-center">
                <button type="button" class="btn-color" (click)="cerrarSesion();">SI, CERRAR SESIÓN</button>
            </div>
            <div class="col-12 mt-4">
                <a type="button" (click)="cerrar()">No, Volver a aplicación</a>
            </div>
        </div>
    </div>
</div>